/**
 * 认证工具 - Token 存储与登录状态管理
 */

const TOKEN_KEY = 'admin_auth_token'
const USER_KEY = 'admin_auth_user'
const TOKEN_EXPIRE_KEY = 'admin_token_expire'

/**
 * 获取 Token（检查过期）
 */
export const getToken = (): string => {
  const token = localStorage.getItem(TOKEN_KEY)
  if (!token) return ''

  // 检查是否过期
  const expireTime = localStorage.getItem(TOKEN_EXPIRE_KEY)
  if (expireTime) {
    const now = Date.now()
    if (now > parseInt(expireTime, 10)) {
      clearAuth()
      return ''
    }
  }

  return token
}

/**
 * 存储 Token（设置过期时间）
 * @param token JWT token
 * @param expireHours 过期时间（小时），默认 24 小时
 */
export const setToken = (token: string, expireHours: number = 24): void => {
  const expireTime = Date.now() + expireHours * 60 * 60 * 1000
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(TOKEN_EXPIRE_KEY, String(expireTime))
}

/**
 * 获取用户信息
 */
export const getUserInfo = (): Record<string, any> | null => {
  const userStr = localStorage.getItem(USER_KEY)
  if (!userStr) return null
  try {
    return JSON.parse(userStr)
  } catch (e) {
    return null
  }
}

/**
 * 存储用户信息
 */
export const setUserInfo = (user: Record<string, any>): void => {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

/**
 * 清除认证信息
 */
export const clearAuth = (): void => {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
  localStorage.removeItem(TOKEN_EXPIRE_KEY)
}

/**
 * 检查是否已登录（token 存在且未过期）
 */
export const isAuthenticated = (): boolean => {
  const token = getToken()
  return !!token
}

/**
 * 获取 Token 剩余有效时间（毫秒）
 */
export const getTokenRemainingTime = (): number => {
  const expireTime = localStorage.getItem(TOKEN_EXPIRE_KEY)
  if (!expireTime) return 0
  return Math.max(0, parseInt(expireTime, 10) - Date.now())
}

/**
 * 续期 Token（延长过期时间）
 */
export const refreshTokenExpire = (expireHours: number = 24): void => {
  const token = getToken()
  if (token) {
    const expireTime = Date.now() + expireHours * 60 * 60 * 1000
    localStorage.setItem(TOKEN_EXPIRE_KEY, String(expireTime))
  }
}
